export default {
  title: 'Taxe et devise',
  subtitle: 'Gérez les catégories de taxe utilisées pour tarifier vos articles de menu.',
};
